import React, { Component } from "react";
import { LabelWithFieldWrapper, InputField } from "./AddTestsForm";
import { languageService } from "../../../Language/language.service";
import AssetsSelection from "../../LampAssets/AssetSelection/AssetSelection";
import { CheckBoxFieldCustom } from "../../AssetTests/AssetTests";

export default class AlertInfoArea extends Component {
  constructor(props) {
    super(props);
    this.changeHandler = this.changeHandler.bind(this);
    this.onUserListChange = this.onUserListChange.bind(this);
  }
  changeHandler(e, blur) {
    let alertInfo = { ...this.props.alertInfo };
    alertInfo[e.target.name] = e.target.value;
    let event = { target: { name: "alertInfo", value: alertInfo } };
    this.props.changeHandler(event, blur);
  }

  //   componentDidUpdate(prevProps, prevState) {
  //     if (this.props.alertInfo !== prevProps.alertInfo) {
  //       this.setState({
  //         alertInfo: this.props.alertInfo ? this.props.alertInfo : { ...defaultAlertInfo },
  //       });
  //     }
  //   }
  onUserListChange(selected) {
    let event = { target: { name: "emailUserIds", value: selected } };
    this.changeHandler(event);
  }
  render() {
    let alertInfo = this.props.alertInfo ? this.props.alertInfo : {};
    return (
      <div>
        <LabelWithFieldWrapper
          postLabel={this.props.postLabel}
          label={languageService(this.props.alertLabel ? this.props.alertLabel : languageService("Alert Days Before Expiry"))}
        >
          <InputField
            inputFieldProps={{ name: "expiryAlertDays", type: "number" }}
            changeHandler={this.changeHandler}
            value={alertInfo.expiryAlertDays}
          />
        </LabelWithFieldWrapper>
        {!this.props.noOverdueAlertCheckbox && (
          <CheckBoxFieldCustom
            value={alertInfo.overdueAlert}
            name="overdueAlert"
            onChangeHandler={this.changeHandler}
            label={"Send Overdue alerts"}
          />
        )}
        {!this.props.noUserList && (
          <AssetsSelection
            options={this.props.alertUserList}
            selected={alertInfo.emailUserIds}
            onAssetChange={this.onUserListChange}
            className={"alert-users"}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SetupPage/GITestAssetTypes/AlertInfoArea.jsx